import CreateFolderDialog from "./folder/create/CreateFolderDialog";
import QRCodeStyleDialog from "./qr-code/style/QRCodeStyleDialog";
import QRCodeFolderDialog from "./qr-code/folder/QRCodeFolderDialog";

/**
 * Renders all dialogs that uses contexts.
 * @author Kacper Faber
 * @since 0.1.9
*/
function DialogsContainer() {
    return (
        <>
            <CreateFolderDialog/>

            <QRCodeFolderDialog/>

            <QRCodeStyleDialog/>
        </>
    );
}

export default DialogsContainer;